import React from 'react';
import PropTypes from 'prop-types';
import { Radio } from 'antd';
import style from './index.scss';
import { RadioButton } from './styled';

const RadioItem = ({ item }) => {
  if (item) {
    const { label, value } = item;
    return <RadioButton value={value}>{label}</RadioButton>;
  }

  return null;
};

RadioItem.propTypes = {
  item: PropTypes.object.isRequired
};

class RadioGroup extends React.Component {
  state = {};

  handleChange = (e) => {
    const { onChange } = this.props;
    if (onChange) {
      onChange(e.target.value);
    }
  };

  render() {
    const { items, defaultValue, size } = this.props;

    if (Array.isArray(items) && items.length > 0) {
      const radioItems = items.map((currentItem, currentItemIndex) => {
        return <RadioItem key={currentItemIndex} item={currentItem} />;
      });

      return (
        <Radio.Group
          className={style.radioGroupContainer}
          value={defaultValue}
          onChange={this.handleChange}
          size={size ? size : 'medium'}>
          {radioItems}
        </Radio.Group>
      );
    }

    return null;
  }
}

RadioGroup.propTypes = {
  items: PropTypes.array.isRequired,
  defaultValue: PropTypes.any,
  onChange: PropTypes.func
};

export default RadioGroup;
